// Pure-data catalogs extracted from GameCanvas.jsx so the main
// component file shrinks without changing any behavior. Everything
// here is static metadata — no canvas/state/refs/hooks — which is
// what makes the extraction safe.

/**
 * POWERUP_INFO — per-drop HUD metadata.
 *
 * Shown in the first-pickup toast so new players learn what each drop
 * does. `duration` is also used as the visible lifetime of the chip in
 * the activePowerups HUD strip (including non-timed instant drops so
 * the player still gets a brief "it happened" indicator).
 */
export const POWERUP_INFO = {
  multi:   { label: "Multi-ball",     desc: "Your comet just split into multiple balls.",  color: "#00ffff", duration: 12000 },
  enlarge: { label: "Wide Paddle",    desc: "Paddle widened for 12 seconds.",                color: "#ffd700", duration: 12000 },
  slow:    { label: "Slow-motion",    desc: "Time slowed down for 8 seconds.",               color: "#ff8c1a", duration:  8000 },
  life:    { label: "Extra Life",     desc: "A bonus life was granted.",                     color: "#ff4fb3", duration:  3000 },
  warp:    { label: "Wormhole Warp",  desc: "Your ball teleported across space.",            color: "#b026ff", duration:  3000 },
  hole:    { label: "Black Hole",     desc: "Nearby blocks were sucked into the void.",      color: "#6b3df5", duration:  3000 },
  // Blood-Red Stingrays — 3 small translucent manta-rays that home in
  // on the nearest boss/Leviathan and tear off chunks of HP. Pure
  // boss-melt power-up; on screens with no boss they still shred any
  // tier-4 brick before dissipating.
  stingray: { label: "Stingray Swarm", desc: "Three blood-red stingrays hunt the nearest boss.", color: "#ff1f3a", duration: 10000 },
};

/**
 * LEGEND_PREVIEW_SFX — Legend modal preview SFX map.
 *
 * Extra Life has its own triumphant chord so it gets a dedicated sound;
 * every other drop shares the generic `powerUp` ascending arpeggio
 * which is what the game itself plays on pickup, so the preview is 1:1
 * with reality.
 */
export const LEGEND_PREVIEW_SFX = {
  multi:   "powerUp",
  enlarge: "powerUp",
  slow:    "powerUp",
  life:    "extraLife",
  warp:    "powerUp",
  hole:    "powerUp",
  stingray: "powerUp",
};

/**
 * DEFERRED_STARTERS — starters that auto-arm at a specific wave instead
 * of at run-mount.
 *
 * Keep this list in sync with the wallet-load useEffect in GameCanvas
 * (which intentionally skips these) and with the wave-trigger logic
 * inside the game loop. Each entry:
 *   { wave, color, label }
 * — color drives the HUD pip + the activation flash colour; label is
 * the user-facing toast text on arming.
 */
export const DEFERRED_STARTERS = {
  "wave-5-plasma": { wave: 5,  color: "#ff66ff", label: "Wave-5 Plasma Boost" },
  "wave-10-comet": { wave: 10, color: "#ff8c42", label: "Wave-10 Comet Storm" },
};
